import { render, staticRenderFns } from "./BackdoorEposReceipt.vue?vue&type=template&id=4757a12e&scoped=true"
import script from "./BackdoorEposReceipt.vue?vue&type=script&lang=js"
export * from "./BackdoorEposReceipt.vue?vue&type=script&lang=js"
import style0 from "./BackdoorEposReceipt.vue?vue&type=style&index=0&id=4757a12e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4757a12e",
  null
  
)

export default component.exports